function roleSelectDirective() {
	return {
		scope : {
			value : '=',
			onRoleChange : '&',
			disabledControl : '=?',
			required: '@?',
			placeholderDir : '@?placeholder'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/roleSelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'roleService', function($scope, $window, alertService, roleService) {

			$scope.isRequired =  angular.isDefined($scope.required);
			$scope.roleItems = [];
			$scope.roleSelected = {
				selected : $scope.value
			};
			
			if ($scope.disabledControl == undefined) {
				$scope.disabledControl = false;
			}

			$scope.loadRoles = function() {
				console.log('cargando roles');
				roleService.searchRoles().then(function(response) {
					console.log('cargando roles OK');
					$scope.roleItems = response.getData().results;
					console.log($scope.roleItems);
				}, function(response){
					
				});
				
				$scope.selectedValue = $scope.roleItems[0];
			};

			$scope.constantChanged = function(constant) {
				$scope.valueWasChangedFromSelector = true;
				if (!angular.isUndefined($scope.value))
					$scope.value = constant;
				if ($scope.onConstantChange != undefined) {
					$scope.onConstantChange({
						constantSelected : constant
					});
				}
			};

		} ],
		link : function(scope, elem, attr) {
			scope.loadRoles();
		}
	};
};

module.directive('roleSelect', [ roleSelectDirective ]);